export default {
    common: {
        inMonth: '{prep} {month}',
        than: 'niż {month}',
        thanSamePeriod: 'niż do tego dnia {month}',
        noCategory: 'Bez kategorii',
        monthLoadFailed: 'Nie udało się pobrać miesiąca.',
        markedPaid: '„{name}" oznaczone jako zapłacone.',
        statusFailed: 'Nie udało się zmienić statusu.',
        expenseAdded: 'Wydatek dodany.',
        expenseSaved: 'Wydatek zapisany.',
        expenseDeleted: 'Wydatek usunięty.',
        addExpense: 'Dodaj wydatek',
        noExpenses: 'Brak wydatków w tym miesiącu.',
        vsAverageNote: 'Porównanie ze średnią z 3 poprzednich miesięcy.',
        markPaidLabel: '{name}: oznacz jako zapłacone',
        markPaid: 'Oznacz jako zapłacone',
        loanInstalment: 'rata kredytu',
    },
    overview: {
        title: 'Przegląd',
        overdueDays: 'po terminie ({n} dzień) | po terminie ({n} dni) | po terminie ({n} dni)',
        today: 'dziś',
        tomorrow: 'jutro',
        inDays: 'za {n} dni',
        nextInstalment: 'Najbliższa rata: {name} · {amount} · {when}',
        balanceTitle: 'BILANS · {month}',
        income: 'Przychody',
        expenses: 'Wydatki',
        paymentsAndInstalments: 'Płatności i raty',
        stillToPay: 'w tym {amount} jeszcze do zapłaty',
        left: 'Zostaje',
        short: 'Brakuje',
        savingRate: '{pct}% przychodów odkładasz',
        overspent: 'wydatki przewyższają przychody',
        noIncome: 'brak przychodów w tym miesiącu',
        budgetPct: '{name}: {pct}% budżetu',
        expensesOf: 'Wydatki · {month}',
        dailyAverage: 'Średnio dziennie',
        forecast: 'Prognoza na koniec',
        expenseCount: 'Liczba wydatków',
        trendHint: 'Ostatnie {n} miesięcy — kliknij słupek, żeby przejść do miesiąca',
        paymentsTitle: 'PŁATNOŚCI · {month}',
        leftToPay: 'Zostało do zapłaty',
        allPaid: 'Wszystko zapłacone',
        paymentsProgress: '{paid} z {all} · {n} pozycja do zapłaty | {paid} z {all} · {n} pozycje do zapłaty | {paid} z {all} · {n} pozycji do zapłaty',
        noListCreate: 'Brak listy na ten miesiąc — utwórz ją w Płatnościach.',
        loansTitle: 'KREDYTY',
        monthlyInstalments: 'Raty miesięcznie',
        toRepay: 'do spłaty {amount}',
        nearestEnd: 'najbliżej koniec: {name} ({n} rata) | najbliżej koniec: {name} ({n} raty) | najbliżej koniec: {name} ({n} rat)',
        noLoans: 'Brak kredytów.',
        commitmentsTitle: 'STAŁE ZOBOWIĄZANIA / MC',
        fixedPart: 'płatności stałe {amount}',
        fixedAvgNote: '(średnio, z kwartalnymi i rocznymi)',
        loansPart: 'raty {amount}',
        plusAverage: 'do tego średnio {amount} wydatków / mies.',
        whereMoneyGoes: 'NA CO IDĄ PIENIĄDZE',
        toPayTitle: 'DO ZAPŁATY',
        overdueCount: '{n} po terminie',
        all: 'Wszystkie',
        allPaidDot: 'Wszystko zapłacone.',
        noList: 'Brak listy płatności na ten miesiąc.',
        andMore: 'i {n} więcej…',
        recentTitle: 'OSTATNIE WYDATKI',
    },
    due: {
        overdue: 'po terminie {n} dzień | po terminie {n} dni | po terminie {n} dni',
        today: 'termin dziś',
        tomorrow: 'termin jutro',
        inDays: 'za {n} dni · {date}',
        by: 'do {date}',
    },
    intervals: {
        monthly: 'co miesiąc',
        quarterly: 'co kwartał',
        yearly: 'co rok',
    },
    form: {
        name: 'Nazwa',
        amount: 'Kwota',
        date: 'Data',
        category: 'Kategoria',
    },
    expenses: {
        title: 'Wydatki',
        today: 'Dzisiaj',
        yesterday: 'Wczoraj',
        receiptSaved: 'Wydatki z paragonu zapisane.',
        fromReceiptHint: 'Wczytaj wydatki ze zdjęcia paragonu',
        fromReceipt: 'Z paragonu',
        spent: 'Wydane',
        perDay: 'Dziennie',
        forecast: 'Prognoza',
        count: 'Wydatków',
        biggest: 'Największy: {name} · {amount}',
        categoryFilter: 'Filtr kategorii',
        search: 'Szukaj wydatku',
        clearFilter: 'Wyczyść filtr',
        filteredSummary: '{n} wydatek · {part} z {total} | {n} wydatki · {part} z {total} | {n} wydatków · {part} z {total}',
        noMatch: 'Nic nie pasuje do filtra',
        empty: 'Brak wydatków w tym miesiącu',
        noMatchHint: 'Zmień frazę albo wyczyść filtr.',
        emptyHint: 'Dodaj wydatek ręcznie albo wczytaj paragon.',
        categories: 'KATEGORIE',
        manage: 'Zarządzaj',
        categoriesHint: 'Kliknij kategorię, żeby zawęzić listę. Porównanie ze średnią z 3 poprzednich miesięcy.',
    },
    income: {
        title: 'Przychody',
        add: 'Dodaj przychód',
        unsupported: 'API nie obsługuje jeszcze przychodów.',
        received: 'Wpłynęło',
        compareSame: 'tyle samo niż {month}',
        compareMore: '{pct}% więcej niż {month}',
        compareLess: '{pct}% mniej niż {month}',
        recurring: 'Stałe',
        oneOff: 'Jednorazowe',
        expected: 'Jeszcze nie wpłynęło (było w poprzednim miesiącu)',
        empty: 'Brak przychodów w tym miesiącu',
        emptyHint: 'Dodaj pensję i inne wpływy — Przegląd policzy z nich bilans.',
        sources: 'ŹRÓDŁA',
        categories: 'Kategorie',
        none: 'Brak przychodów.',
        count: '{n} wpływ w tym miesiącu. | {n} wpływy w tym miesiącu. | {n} wpływów w tym miesiącu.',
        form: {
            source: 'Skąd',
            sourcePlaceholder: 'np. Pensja',
            noCategories: 'Kategorie przychodów dodasz w zakładce Kategorie.',
            recurring: 'Powtarza się',
            recurringHint: 'Co miesiąc (np. pensja) — liczy się do prognozy',
        },
        dialog: {
            edit: 'Edytuj przychód',
            new: 'Nowy przychód',
        },
        flash: {
            added: 'Przychód dodany.',
            saved: 'Przychód zapisany.',
            saveFailed: 'Nie udało się zapisać przychodu.',
            deleted: 'Przychód usunięty.',
            deleteFailed: 'Nie udało się usunąć przychodu.',
        },
    },
    categories: {
        title: 'Kategorie',
        count: '{n} kategoria | {n} kategorie | {n} kategorii',
        add: 'Dodaj kategorię',
        edit: 'Edytuj kategorię',
        tabs: {
            expenses: 'Wydatki',
            payments: 'Płatności',
            income: 'Przychody',
        },
        thisMonth: '{amount} w tym miesiącu',
        average: 'średnio {amount} / mies.',
        noHistory: 'brak wydatków w 3 poprzednich miesiącach',
        incomeCount: '{n} wpływ | {n} wpływy | {n} wpływów',
        noIncome: 'brak wpływów w tym miesiącu',
        fixedCount: '{n} płatność stała | {n} płatności stałe | {n} płatności stałych',
        loanCount: '{n} kredyt | {n} kredyty | {n} kredytów',
        perMonth: '{amount} / mies.',
        nothingAssigned: 'nic nie jest przypisane',
        placeholder: {
            expenses: 'np. Jedzenie',
            payments: 'np. Mieszkanie',
            income: 'np. Pensja',
        },
        budget: 'Budżet miesięczny',
        budgetHint: 'Limit na miesiąc — puste = bez budżetu.',
        saveFailed: 'Nie udało się zapisać kategorii.',
        deleteMessage: {
            expenses: 'Kategorii przypisanej do wydatków nie da się usunąć — najpierw zmień kategorię w tych wydatkach.',
            payments: 'Płatności stałe, kredyty i pozycje list zostaną, tylko bez kategorii.',
            income: 'Przychody zostaną, tylko bez kategorii.',
        },
        deleted: 'Kategoria usunięta.',
        inUse: 'Kategoria ma przypisane wydatki — najpierw zmień w nich kategorię.',
        deleteFailed: 'Nie udało się usunąć kategorii.',
        intro: {
            expenses: 'Kategoria jest wymagana przy każdym wydatku. Kwoty: bieżący miesiąc i średnia z 3 poprzednich; budżet ustawisz, klikając kategorię.',
            payments: 'Grupują płatności stałe, kredyty i pozycje listy miesiąca. Kwota: ile miesięcznie idzie na płatności stałe i raty w kategorii.',
            income: 'Źródła przychodów, np. pensja, premie, zwroty. Kwota: ile wpłynęło w tym miesiącu.',
        },
        unsupported: {
            expenses: 'API nie obsługuje jeszcze kategorii wydatków.',
            payments: 'API nie obsługuje jeszcze kategorii płatności.',
            income: 'API nie obsługuje jeszcze kategorii przychodów.',
        },
        empty: {
            expenses: 'Brak kategorii wydatków',
            payments: 'Brak kategorii płatności',
            income: 'Brak kategorii przychodów',
        },
        newTitle: {
            expenses: 'Nowa kategoria wydatków',
            payments: 'Nowa kategoria płatności',
            income: 'Nowa kategoria przychodów',
        },
        rename: 'Zmień nazwę: {name}',
        budgetUsage: '{pct}% z {limit}',
        delete: 'Usuń kategorię',
        deleteNamed: 'Usuń kategorię {name}',
        confirmTitle: 'Usunąć kategorię?',
    },
    loans: {
        title: 'Kredyty',
        add: 'Dodaj kredyt',
        instalments: '{n} rata | {n} raty | {n} rat',
        years: '{n} rok | {n} lata | {n} lat',
        yearsMonths: '{years} i {m} mies.',
        due: {
            lateShort: 'po terminie od {n} dnia | po terminie od {n} dni | po terminie od {n} dni',
            lateText: 'Rata po terminie — {date} ({n} dzień temu) | Rata po terminie — {date} ({n} dni temu) | Rata po terminie — {date} ({n} dni temu)',
            todayShort: 'rata dziś',
            todayText: 'Rata dziś — {date}',
            tomorrowShort: 'rata jutro',
            tomorrowText: 'Rata jutro — {date}',
            inDaysShort: 'rata za {n} dni',
            inDaysText: 'Rata za {n} dni — {date}',
            nextText: 'Najbliższa rata {date} · za {n} dni',
        },
        sort: {
            label: 'Sortowanie',
            next: 'Sortuj: najbliższa rata',
            end: 'Sortuj: koniec',
            name: 'Sortuj: nazwa',
            instalment: 'Sortuj: rata',
            left: 'Sortuj: zostało',
        },
        form: {
            categoryHint: 'Raty na nowych listach miesiąca dostaną tę kategorię.',
            categoryHintEmpty: 'Najpierw dodaj kategorie w „Kategorie płatności".',
            where: 'Gdzie',
            wherePlaceholderLegacy: 'np. Bank X',
            wherePlaceholder: 'np. PKO hipoteka / Karta Erste',
            totalAmount: 'Kwota kredytu',
            instalment: 'Rata',
            instalmentsLeft: 'Rat do końca',
            end: 'Koniec',
            kind: 'Rodzaj',
            kindInstalment: 'Kredyt ratalny (ma datę końca)',
            kindRevolving: 'Karta kredytowa / limit (bez daty końca)',
            capital: 'Pozostały kapitał / zadłużenie',
            capitalHint: 'Z aplikacji banku. Każda zapłacona rata zmniejsza go o swoją część kapitałową.',
            minimumPayment: 'Spłata minimalna',
            minimumPaymentHint: 'Z banku — najmniej, ile trzeba spłacić z długu w miesiącu (odsetki osobno).',
            plannedPayment: 'Rata / planowana spłata',
            plannedPaymentHint: 'Kredyt: obecna rata (zmień, gdy bank ją przeliczy). Karta: ile długu spłacasz co miesiąc — co najmniej minimalna; odsetki dochodzą do tego.',
            interestRate: 'Oprocentowanie z banku',
            interestRateHint: 'Oprocentowanie nominalne z banku (nie RRSO), roczne. Przy kredycie opcjonalne — bez niego wyliczę je z raty.',
            instalmentType: 'Raty',
            equal: 'Równe',
            decreasing: 'Malejące',
            paymentDay: 'Dzień płatności',
            paymentDayHint: '29–31 w krótszych miesiącach = ostatni dzień.',
            nextPayment: 'Najbliższa płatność',
            nextPaymentHintEdit: 'Zmień, jeśli termin się przesunął.',
            nextPaymentHint: 'Puste = najbliższy dzień płatności od dziś.',
            lastInstalment: 'Ostatnia rata',
            lastInstalmentHint: 'Z harmonogramu banku.',
            calc: 'Wyliczenie',
        },
        overpayModes: {
            shorten: 'krótszy okres',
            lower: 'niższa rata',
        },
        flash: {
            paidSplit: 'Rata „{name}" zapłacona — {capital} kapitału, {interest} odsetek.',
            paidAmount: 'Rata „{name}" zapłacona — {amount}.',
            noInstalmentsLeft: 'Ten kredyt nie ma już rat do spłaty.',
            payFailed: 'Nie udało się oznaczyć raty.',
            reverted: 'Cofnięto ostatnią ratę „{name}".',
            revertFailed: 'Nie udało się cofnąć raty.',
            overpaid: 'Nadpłata {amount} zapisana — kapitał {capital}.',
            overpayReverted: 'Cofnięto nadpłatę {amount}.',
            overpayRevertFailed: 'Nie udało się cofnąć nadpłaty.',
        },
        capitalUnchecked: 'kapitał niesprawdzony z bankiem',
        capitalChecked: 'kapitał sprawdzony {n} miesiąc temu | kapitał sprawdzony {n} miesiące temu | kapitał sprawdzony {n} miesięcy temu',
        capitalStale: '{age} — przepisz go z aplikacji banku',
        dialog: {
            new: 'Nowy kredyt',
            edit: 'Edytuj kredyt',
            editRevolving: 'Edytuj kartę / limit',
        },
        principal: 'Kapitał',
        toRepay: 'Do spłaty',
        ofWhichInterest: 'W tym odsetki',
        nextDue: 'Najbliższa rata: {name} · {date} · {amount}',
        groupMonthly: '{amount} / mc',
        groupCapital: 'kapitał {amount}',
        payableOn: 'Płatna {day}. dnia miesiąca',
        everyMonth: 'co mc',
        editNamed: 'Edytuj: {name}',
        paidOff: 'Spłacony',
        monthsToRepay: '{n} mies. do spłaty',
        revolvingBadge: 'karta / limit',
        payableDay: 'płatna {day}. dnia',
        lastOn: 'ostatnia {date}',
        revertTitle: 'Cofnij ostatnio zapłaconą ratę — {name}',
        revertLabel: 'Cofnij ostatnią ratę: {name}',
        payTitle: 'Rata zapłacona: zmniejsza kapitał o część kapitałową, oznacza ratę na liście miesiąca',
        paid: 'Zapłaciłem',
        thisMonth: 'W tym miesiącu',
        repayPlusInterest: '{repay} spłaty + {interest} odsetek',
        minimum: 'min. {amount}',
        debt: 'Zadłużenie',
        principalLeft: 'Pozostały kapitał',
        fillIn: 'Uzupełnij',
        interestLeft: 'Odsetki do końca',
        rateYearlyBank: '{rate}% rocznie (bank)',
        rateYearlyApprox: 'ok. {rate}% rocznie',
        neverPaidOff: 'Bez planowanej spłaty dług nie maleje — wpisz, ile spłacasz co miesiąc.',
        hidePlan: 'Zwiń plan spłaty',
        plan: 'Plan spłaty',
        overpay: 'Nadpłać',
        empty: 'Brak kredytów',
        emptyHint: 'Raty kredytów trafiają też na listę płatności miesięcznych.',
        undo: 'Cofnij',
        calc: {
            belowMinimum: 'Planowana spłata jest niższa od minimalnej.',
            never: 'Bez spłaty dług nie maleje — co miesiąc płacisz same odsetki, ok. {amount}.',
            dueNow: 'W tym miesiącu do zapłaty {due} = {repay} spłaty + {interest} odsetek',
            payoff: 'Spłacisz w {months} · odsetki razem {interest}',
            monthsShort: '{n} mies.',
            noNewPurchases: '(bez nowych zakupów kartą)',
            invalid: 'Ta rata nie spłaci tego kapitału w {n} racie — sprawdź kwoty albo datę ostatniej raty. | Ta rata nie spłaci tego kapitału w {n} ratach — sprawdź kwoty albo datę ostatniej raty. | Ta rata nie spłaci tego kapitału w {n} ratach — sprawdź kwoty albo datę ostatniej raty.',
            summary: 'Zostało {count} · do spłaty {total} · w tym odsetki {interest}',
            mismatch: 'Z raty, kapitału i dat wychodzi ok. {implied}%, a bank podaje {rate}%. Sprawdź datę ostatniej raty, kapitał albo czy rata zawiera ubezpieczenie.',
            rateBank: 'Oprocentowanie {rate} rocznie (z banku)',
            rateApprox: 'Oprocentowanie ok. {rate} rocznie',
            nextSplit: 'najbliższa rata: {capital} kapitału + {interest} odsetek',
            forecastNote: 'Prognoza przy obecnej racie. Gdy bank zmieni ratę albo po nadpłacie — popraw ratę (albo datę ostatniej raty).',
            enterCapital: '— wpisz kapitał, a policzę odsetki i oprocentowanie.',
            hint: 'Podaj ratę, dzień płatności i ostatnią ratę — policzę liczbę rat, odsetki i oprocentowanie.',
        },
        history: {
            title: 'Zapłacone raty',
            loading: 'Ładuję…',
            split: 'kapitał {capital} · odsetki {interest}',
            empty: 'Jeszcze żadna rata nie została oznaczona jako zapłacona.',
            overpayments: 'Nadpłaty',
            revertOverpayment: 'Cofnij nadpłatę — kapitał, rata i data końca wracają do stanu sprzed niej',
        },
    },
    payments: {
        title: 'Płatności',
        addItem: 'Dodaj pozycję',
        addFixed: 'Dodaj płatność stałą',
        intervals: {
            monthly: 'Co miesiąc',
            quarterly: 'Co kwartał',
            yearly: 'Co rok',
        },
        yearlyDay: '{month}, {day}.',
        dayOf: '{day}. dnia',
        paid: 'zapłacone',
        paidOn: 'zapłacone {day} {month}',
        tabs: {
            month: 'Ten miesiąc',
            fixed: 'Płatności stałe',
        },
        options: {
            title: 'Opcje',
            linkActive: 'Zapłacone trafiają do wydatków',
            refresh: 'Odśwież z definicji',
            refreshHint: 'Dociąga nowe płatności stałe i raty, statusy zostają.',
            addAsExpense: 'Zapłacone dodawaj do wydatków',
            expenseCategory: 'Kategoria wydatku',
            expenseCategoryLabel: 'Kategoria wydatku dla zapłaconych płatności',
            pickCategory: 'Wybierz kategorię wydatku.',
            deviceSetting: 'Ustawienie tego urządzenia.',
        },
        categoriesLink: 'Kategorie płatności',
        toPay: 'Do zapłaty',
        items: '{n} pozycja | {n} pozycje | {n} pozycji',
        paidTitle: 'Zapłacone',
        skippedCount: '{n} pominięte',
        monthTotal: 'Razem w miesiącu',
        progressLabel: 'Zapłacona część miesiąca',
        allPaidMonth: 'Wszystko na ten miesiąc zapłacone.',
        nothingPaid: 'Jeszcze nic nie zapłacone w tym miesiącu.',
        listEmpty: 'Lista jest pusta — dodaj pozycję albo odśwież z definicji w „Opcje”.',
        noList: 'Brak listy na {month}',
        noListHint: 'Utwórz ją — pozycje powstaną z płatności stałych i rat kredytów.',
        createList: 'Utwórz listę',
        fixedIntro: 'Trafiają na każdą nową listę miesiąca razem z ratami kredytów.',
        monthlyAverage: 'Średnio miesięcznie',
        monthlyTotal: 'Razem miesięcznie',
        fixedEmpty: 'Brak płatności stałych — dodaj czynsz, prąd, abonamenty.',
        form: {
            dueDate: 'Termin',
            optional: 'Opcjonalnie',
            itemPlaceholder: 'np. Prąd',
            fixedPlaceholder: 'np. Abonament',
            fixedHint: 'Trafi na każdą generowaną listę miesięczną.',
            interval: 'Jak często',
            startMonth: 'Pierwszy miesiąc',
            startMonthHint: 'Dla kwartalnych i rocznych — od niego liczą się kolejne.',
        },
        confirm: {
            title: 'Usunąć pozycję z listy?',
            message: 'Zniknie tylko z listy tego miesiąca — definicja płatności stałej zostaje.',
        },
        dialog: {
            newItem: 'Nowa pozycja listy',
            editItem: 'Edytuj pozycję',
            editFixed: 'Edytuj płatność stałą',
            newFixed: 'Nowa płatność stała',
        },
        flash: {
            paidAsExpense: '„{name}" zapłacone i dodane do wydatków.',
            itemSaveFailed: 'Nie udało się zapisać pozycji.',
            itemDeleteFailed: 'Nie udało się usunąć pozycji.',
            createFailed: 'Nie udało się utworzyć listy na ten miesiąc.',
            refreshFailed: 'Nie udało się odświeżyć listy.',
            itemAddFailed: 'Nie udało się dodać pozycji.',
            fixedSaveFailed: 'Nie udało się zapisać płatności stałej.',
            deleteFailed: 'Nie udało się usunąć.',
        },
    },
    bars: {
        ofLimit: 'z {amount}',
        over: 'Budżet przekroczony o {amount}',
        willExceed: 'Przy tym tempie: ~{amount} na koniec miesiąca',
        leftWarn: 'Zostało {amount} z budżetu',
        left: 'zostało {amount} z budżetu',
        avgHint: 'Średnio {amount} / mies. w poprzednich miesiącach (w trwającym miesiącu proporcjonalnie do dni)',
        vsAvg: '{pct}% vs śr.',
        asUsual: 'jak zwykle',
    },
    delta: {
        noData: 'brak danych do porównania',
        same: 'tyle samo {suffix}',
        more: '{pct}% więcej {suffix}',
        less: '{pct}% mniej {suffix}',
    },
    expenseForm: {
        name: 'Na co',
        namePlaceholder: 'np. zakupy w Biedronce',
        noCategories: 'Najpierw dodaj kategorię w zakładce Kategorie.',
        saveFailed: 'Nie udało się zapisać wydatku.',
        deleteFailed: 'Nie udało się usunąć wydatku.',
        edit: 'Edytuj wydatek',
        new: 'Nowy wydatek',
    },
    chart: {
        thousands: '{n} tys.',
        average: 'średnio {amount}',
        caption: 'Wydatki w kolejnych miesiącach',
    },
    switcher: {
        prev: 'Poprzedni miesiąc',
        next: 'Następny miesiąc',
        today: 'Dziś',
    },
    row: {
        undoPaid: 'Cofnij — do zapłaty',
        restore: 'Przywróć do zapłaty',
        skipped: 'pominięte w tym miesiącu',
        noDueDate: 'bez terminu',
        inExpenses: 'w wydatkach',
        skipHint: 'Pomiń w tym miesiącu — nie wlicza się do sum',
        restoreNamed: 'Przywróć {name}',
        skipNamed: 'Pomiń {name}',
    },
    plan: {
        spanJoin: '{years} i {months}',
        monthlyRepayment: 'Spłacam z długu miesięcznie',
        plusInterest: '(+ odsetki)',
        compareLabel: 'Porównanie kwot spłaty',
        minimum: 'minimum',
        current: 'plan',
        compareResult: '{months} · odsetki {interest}',
        neverRepays: 'nie spłaci długu',
        never: 'Bez spłaty dług nie maleje — co miesiąc płacisz same odsetki, ok. {amount}. Wpisz kwotę spłaty.',
        missingData: 'Brakuje danych do planu: kapitału, raty albo oprocentowania.',
        end: 'Koniec spłaty',
        left: 'Zostało',
        totalInterest: 'Odsetki razem',
        totalPaid: 'Zapłacisz razem',
        chartTitle: 'Zadłużenie w czasie',
        chartLabel: 'Zadłużenie maleje z {amount} do zera w {n} miesięcy',
        now: 'Teraz',
        balance: 'saldo {amount}',
        payment: 'wpłata {paid}: {capital} kapitał · {interest} odsetki',
        scheduleMonthly: 'Harmonogram miesięczny',
        scheduleYearly: 'Harmonogram rok po roku',
        showYears: 'Pokaż rok po roku',
        showMonths: 'Pokaż miesiące',
        month: 'Miesiąc',
        year: 'Rok',
        payments: 'Wpłaty',
        interest: 'Odsetki',
        endBalance: 'Saldo na koniec',
        forecast: 'Prognoza przy obecnym oprocentowaniu ({rate}% rocznie).',
        forecastRevolving: 'Prognoza przy obecnym oprocentowaniu ({rate}% rocznie) i bez nowych zakupów kartą.',
    },
    overpay: {
        amountRequired: 'Podaj kwotę nadpłaty.',
        saveFailed: 'Nie udało się zapisać nadpłaty.',
        title: 'Nadpłata — {name}',
        close: 'Zamknij',
        amount: 'Kwota nadpłaty',
        moreThanDebt: 'Więcej niż zadłużenie ({amount}).',
        moreThanCapital: 'Więcej niż pozostały kapitał ({amount}).',
        question: 'Co robi bank z nadpłatą?',
        variant: 'Wariant nadpłaty',
        shorten: 'Krótszy okres',
        shortenHint: 'ta sama rata, wcześniejszy koniec',
        lower: 'Niższa rata',
        lowerHint: 'ten sam koniec, mniejsza rata',
        endLabel: 'koniec:',
        monthsEarlier: '({n} mies. wcześniej)',
        newInstalment: 'nowa rata:',
        youSave: 'oszczędzasz {amount} odsetek',
        useCalc: 'Użyj wyliczenia',
        bankOther: 'Bank podał inne wartości?',
        bankInstalment: 'Nowa rata z banku',
        bankInstalmentPlaceholder: 'np. 1650,00',
        bankEnd: 'Nowa data ostatniej raty z banku',
        debtDrops: 'Zadłużenie spadnie do {amount}.',
        payoffIn: 'Przy obecnym planie spłacisz w {n} mies.',
        youSaveApprox: 'oszczędzasz ok. {amount} odsetek',
        capitalDrops: 'Kapitał spadnie do {amount}.',
        previewNeeds: 'Do podglądu potrzebny jest pozostały kapitał i oprocentowanie kredytu.',
        note: 'Notatka — opcjonalnie',
        notePlaceholder: 'np. z premii',
        cancel: 'Anuluj',
        saving: 'Zapisuję…',
        save: 'Zapisz nadpłatę',
    },
    loansMonth: {
        status: {
            paid: 'zapłacona',
            due: 'do zapłaty',
            late: 'po terminie',
        },
        title: 'Raty w tym miesiącu · {month}',
        total: 'Razem {amount}',
        totalLower: 'razem {amount}',
        paid: 'zapłacone {amount}',
        left: 'zostało {amount}',
        allPaid: 'wszystko zapłacone',
        next: 'najbliższa {day}. ({name})',
        chartLabel: 'Raty kredytów w dniach miesiąca: {month}',
        today: 'dziś',
        noInstalments: 'bez rat',
    },
    timeline: {
        ranges: {
            year: 'Rok',
            threeYears: '3 lata',
            all: 'Do końca',
        },
        noPlan: 'bez planu spłaty',
        title: 'Raty miesięcznie w czasie',
        now: 'Teraz: {amount} w {month}',
        stillToPay: '{amount} jeszcze do zapłaty',
        nextChange: 'od {month} o {amount} mniej ({names})',
        rangeLabel: 'Zakres osi czasu',
        chartLabel: 'Raty kredytów miesięcznie od {from} do {to}',
        nowMarker: 'teraz',
        past: 'było',
        forecast: 'prognoza',
        noList: 'brak listy płatności z tego miesiąca',
        unpaid: 'niezapłacone',
        legendPast: 'było (z list płatności)',
        legendCurrent: 'bieżący miesiąc',
        loadingPast: 'wczytuję poprzednie miesiące…',
        lanesTitle: 'Kiedy kończą się kredyty',
        perMonth: '{amount}/mc',
    },
    import: {
        newCategoryOption: '+ nowa kategoria',
        tooManyFiles: 'Najwyżej {n} plików naraz.',
        unsupportedType: '{name}: obsługujemy JPG, PNG, WEBP i PDF.',
        fileTooLarge: '{name} jest większy niż 20 MB.',
        totalTooLarge: 'Łącznie nie więcej niż 45 MB.',
        noneFound: 'Nie wykryto żadnych wydatków na zdjęciach.',
        invalidImages: 'Nie przesłano poprawnych zdjęć.',
        noResponse: 'Usługa analizy paragonów nie odpowiedziała. Spróbuj ponownie.',
        notConfigured: 'Analiza paragonów nie jest skonfigurowana.',
        analyzeFailed: 'Nie udało się przeanalizować zdjęć.',
        saveFailed: 'Nie udało się zapisać wydatków.',
        title: 'Import ze zdjęcia',
        uploadHint: 'Zdjęcia paragonów albo PDF — resztę wyciągnie analiza.',
        reviewHint: 'Sprawdź propozycje przed zapisem.',
        chooseFiles: 'Wybierz pliki',
        takePhoto: 'Zrób zdjęcie',
        limits: 'do {n} plików, łącznie 45 MB',
        removeFile: 'Usuń plik',
        note: 'Podpowiedź dla analizy',
        notePlaceholder: 'np. zakupy spożywcze na tydzień',
        namePlaceholder: 'nazwa wydatku',
        pickCategory: 'Wybierz kategorię',
        newCategoryName: 'Nazwa nowej kategorii',
        newCategoryPlaceholder: 'np. Apteka',
        removeRow: 'Usuń pozycję',
        addRow: 'Dodaj pozycję ręcznie',
        back: 'Wróć do plików',
        analyzing: 'Analizuję…',
        analyze: 'Przeanalizuj',
        save: 'Zapisz {n} wydatek | Zapisz {n} wydatki | Zapisz {n} wydatków',
    },
};
